import React from 'react';

interface SeparatorProps {
  className?: string;
}

export const Separator: React.FC<SeparatorProps> = ({ className = '' }) => {
  return (
    <hr className={`border-gray-200 dark:border-gray-700 ${className}`} />
  );
};
